import { Flex } from 'antd';
import cx from 'clsx';
import React from 'react';
import Icon from '../icon';
import styles from './index.module.scss';

const TextWithIcon = (props) => {
  const {
    text,
    textColor,
    component,
    className,
    icon,
    iconSize,
    iconColor,
    align = 'center',
    iconStyles = {},
    gap = 4,
  } = props;
  return (
    <Flex align={align} gap={gap} className={cx(className, styles.textWithIcon)}>
      <Icon icon={icon} iconSize={iconSize} color={iconColor} hasBackground={false} />
      {text ? <span style={{ color: textColor }}>{text}</span> : component}
    </Flex>
  );
};

TextWithIcon.defaultProps = {
  iconSize: '14px',
  iconColor: '#B6B8B9',
  icon: 'QuestionCircleOutlined',
};

export default TextWithIcon;
